<template>
  <TooltipIconButton
    icon="mdi-trash-can-outline"
    tooltipText="tooltip.delete"
    :color="color"
    :disabled="disabled"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'DeleteButton',
  props: {
    color: {
      type: String,
      default: 'red',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
